export default {
    modal: {
        position: "fixed", /* Stay in place */
        zIndex: "999999999999 !important", /* Sit on top */
        left: 0,
        top: 0,
        width: "100%", /* Full width */
        height: "100%", /* Full height */
        overflow: "auto", /* Enable scroll if needed */
        backgroundColor: "rgba(0,0,0,0.2)" /* Black w/ opacity */,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    },
    icon: {
        marginRight: "10px",
    },
    heading: {
        display: "flex",
        alignItems: "center",
        alignSelf: "flex-start",
        fontFamily: '"Open Sans", sans-serif',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '18px',
        lineHeight: '20px',
        letterSpacing: '0.23px',
        color: '#6C7B94',
        padding: "0px 40px",
    },
    /* Modal Content */
    modalCont: {
        backgroundColor: "#fefefe",
        borderRadius: '4px',
        maxWidth: '600px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        boxSizing: 'border-box',
        minHeight: 277,
        '&.thin': {
            padding: '10px 42px 42px 42px'
        },
        '&.thinner': {
            padding: '12px',
            width: 'auto'
        }
    },
    modalAction: {
        margin: "12px 0px",
        '& >button:nth-child(2)': {
            marginLeft: "25px"
        },
        '& button': {
            minWidth: "195px",
        },
    },
    modalContent: {
        fontFamily: '"Open Sans", sans-serif',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0.23px',
        color: '#6C7B94',
        padding: "0px 40px",
    },
    warningInfo: {
        marginTop: 6,
        padding: '6px 12px',
        backgroundColor: '#ffebde',
        lineHeight: 1.5
    },
    footer: {
        backgroundColor: '#ECEFF6',
        borderTop: 'none',
        fontFamily: '"Open Sans", sans-serif',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0.23px',
        color: '#6C7B94',
        padding: '18px 40px',
        marginTop: '40px',
        borderBottomLeftRadius: '4px',
        borderBottomRightRadius: '4px',
    }
};
